<template>
  <div class="cookie-consent-component" v-if="active">
    <div class="message">
      We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of
      our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've
      collected from your use of their services.
    </div>
    <div class="buttons pl-0 pl-md-2">
      <button class="btn reject" @click="consent(false)">Reject</button>
      <button class="btn accept" @click="consent(true)">Accept</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.cookie-consent-component {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 30px;
  box-shadow: $drop-shadow;

  .message {
    flex: 1;
  }

  .buttons {
    .btn {
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: bold;
      color: #fff;
      margin-left: 10px;
      border-radius: 0;

      &.reject {
        background: $brand-color-2;
      }

      &.accept {
        background: $brand-color-1;
      }
    }
  }
}

@media (max-width: $md-1) {
  .cookie-consent-component {
    flex-direction: column;

    .message {
      text-align: center;
    }

    .buttons {
      margin-top: 20px;
    }
  }
}
</style>

<script>
export default {
  name: "CookieConsent",
  data() {
    return {
      active: true,
    };
  },
  mounted() {
    this.active = localStorage.getItem("CookieConsent") === null;
  },
  methods: {
    consent(value) {
      this.active = false;
      localStorage.setItem("CookieConsent", value ? "yes" : "no");
    },
  },
};
</script>
